import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';

const initialData = {
  addNoteStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'recordAddNotes',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postSystemNotesData: (state, action) => {
      state.addNoteStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
    },
    resetStatus: (state) => {
      state.addNoteStatus = null;
      state.errorMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.addNoteStatus = null;
    },
  },
});
const {postSystemNotesData, fetchStart, resetMsg, fetchError, resetStatus} = slice.actions;

export default slice.reducer;

export const AddNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/recordformatnotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetPostStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const NotesResetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
